import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "editor"
}
const _hoisted_2 = { class: "editor-menubar" }

import { ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { EditorContent, useEditor } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import { Underline } from '@tiptap/extension-underline';
import { Link } from '@tiptap/extension-link';
import { Image } from '@tiptap/extension-image';
import AppEditorButton from './AppEditorButton.vue';
import AppEditorLink from './AppEditorLink.vue';

interface AppEditorProps {
	errors?: string[];
	label: string;
	modelValue: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppEditor',
  props: {
    errors: { default: () => [] },
    label: {},
    modelValue: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;

const editingLink = ref(false);
const editor = useEditor({
	content: props.modelValue,
	extensions: [
		StarterKit,
		Underline,
		Link.configure({ openOnClick: false }),
		Image,
	],
	onUpdate() {
		emit('update:modelValue', editor.value?.getHTML());
	},
});

watch(() => props.modelValue, newValue => {
	if (editor.value && editor.value.getHTML() !== newValue) {
		editor.value.commands.setContent(props.modelValue, false);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(editor))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor).commands.focus()))
          }, _toDisplayString(_ctx.label), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "form-error"
            }, _toDisplayString(error), 1))
          }), 128)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Fetstil'),
              icon: "bold",
              class: _normalizeClass({ active: _unref(editor).isActive('bold') }),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleBold().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Kursiv'),
              icon: "italic",
              class: _normalizeClass({ active: _unref(editor).isActive('italic') }),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleItalic().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Genomstruken'),
              icon: "strikethrough",
              class: _normalizeClass({ active: _unref(editor).isActive('strike') }),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleStrike().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Understruken'),
              icon: "underline",
              class: _normalizeClass({ active: _unref(editor).isActive('underline') }),
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleUnderline().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Stycke'),
              icon: "paragraph",
              class: _normalizeClass({ active: _unref(editor).isActive('paragraph') }),
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(editor).chain().focus().setParagraph().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Rubrik nivå 1'),
              text: "H1",
              class: _normalizeClass({ active: _unref(editor).isActive('heading', { level: 1}) }),
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleHeading({level: 1}).run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Rubrik nivå 2'),
              text: "H2",
              class: _normalizeClass({ active: _unref(editor).isActive('heading', { level: 2}) }),
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleHeading({level: 2}).run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Rubrik nivå 3'),
              text: "H3",
              class: _normalizeClass({ active: _unref(editor).isActive('heading', { level: 3}) }),
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleHeading({level: 3}).run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Oordnad lista'),
              icon: "list-ul",
              class: _normalizeClass({ active: _unref(editor).isActive('bullet_list') }),
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleBulletList().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Ordnad lista'),
              icon: "list-ol",
              class: _normalizeClass({ active: _unref(editor).isActive('ordered_list') }),
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_unref(editor).chain().focus().toggleOrderedList().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Avdelare'),
              icon: "horizontal-rule",
              class: _normalizeClass({ active: _unref(editor).isActive('horizontal_rule') }),
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_unref(editor).chain().focus().setHorizontalRule().run()), ["prevent"]))
            }, null, 8, ["title", "class"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Ångra'),
              icon: "undo",
              disabled: !_unref(editor).can().undo(),
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_unref(editor).chain().focus().undo().run()), ["prevent"]))
            }, null, 8, ["title", "disabled"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Gör om'),
              icon: "redo",
              disabled: !_unref(editor).can().redo(),
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_unref(editor).chain().focus().redo().run()), ["prevent"]))
            }, null, 8, ["title", "disabled"]),
            _createVNode(AppEditorButton, {
              title: _unref($gettext)('Länk'),
              icon: "link",
              class: _normalizeClass({ active: _unref(editor).isActive('link') }),
              onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (editingLink.value = true), ["prevent"]))
            }, null, 8, ["title", "class"])
          ]),
          _createVNode(_unref(EditorContent), {
            class: "editor-content",
            editor: _unref(editor)
          }, null, 8, ["editor"])
        ]))
      : _createCommentVNode("", true),
    (editingLink.value)
      ? (_openBlock(), _createBlock(AppEditorLink, {
          key: 1,
          editor: _unref(editor),
          onClose: _cache[15] || (_cache[15] = ($event: any) => (editingLink.value = false))
        }, null, 8, ["editor"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})